import { AnalyticsContextValue, NotAvailable } from '@ui-common/analytics'
import { useSendPageViewEvent } from '@ui-common/hooks'
import { getLanguage, getSourceChannel } from '@ui-common/utils'
import { createContext, PropsWithChildren, use, useMemo } from 'react'

import { WizardStep } from '../wizard/wizardMachine'
import { getAnalyticsNameForPage, IfpLoansAnalyticsService } from './service'

type AnalyticsContext = AnalyticsContextValue<IfpLoansAnalyticsService>

export const IfpLoansAnalyticsContext = createContext<AnalyticsContext>({
  analyticsService: new IfpLoansAnalyticsService(),
})

export const IfpLoansAnalyticsProvider = ({ children }: PropsWithChildren) => {
  const analyticsProviderValue = useMemo(
    () => ({
      analyticsService: new IfpLoansAnalyticsService({
        flow: NotAvailable,
        product: NotAvailable,
        src: getSourceChannel() ?? NotAvailable,
        ui_lang: getLanguage(),
        version: import.meta.env.VITE_APP_VERSION ?? NotAvailable,
      }),
    }),
    [],
  )

  return <IfpLoansAnalyticsContext value={analyticsProviderValue}>{children}</IfpLoansAnalyticsContext>
}

export const useIfpAnalyticsService = () => {
  const context = use(IfpLoansAnalyticsContext)

  if (context === undefined) {
    throw new Error('useIfpAnalyticsService must be used within a IfpLoansAnalyticsProvider')
  }

  return context
}

export const useIfpPageViewEvent = (step: WizardStep): void => {
  const { analyticsService } = useIfpAnalyticsService()
  useSendPageViewEvent(analyticsService, getAnalyticsNameForPage(step))
}
